export const CARD_COLOR_API_URI = '/rest/greenhopper/1.0/cardcolors';
